import { useTranslation } from 'next-i18next'
import React from 'react'

/**
 * Three marketing pillars: Ahorro / Comodidad / Flexibilidad.
 *
 * Editorial value strip — no card chrome. H2 on a 4-col left rail; the three
 * pillars sit in hairline-divided columns on the right (stacked with
 * hairline rows on mobile). The italic blue title carries each pillar, so
 * the body copy can stay quiet. The earlier treatment (three identical
 * pale cards) read as a template grid; the hairline strip matches the
 * `DurationTiers` / `TrustSignals` rhythm further down the page.
 */

const PILLAR_KEYS = ['AHORRO', 'COMODIDAD', 'FLEXIBILIDAD'] as const

const ThreePillars = () => {
  const { t } = useTranslation('page_almacenamiento_a_domicilio')

  return (
    <section
      aria-labelledby="pillars-heading"
      className="border-t border-ink-100/15 bg-white-500 py-16 md:py-24"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-5 md:grid-cols-12 md:gap-14 md:px-10">
        <h2
          id="pillars-heading"
          className="font-display text-[26px] leading-[1.15] font-medium tracking-[-0.01em] text-ink-700 md:col-span-4 md:text-[36px]"
        >
          {t('PILLARS.TITLE')}
        </h2>

        <ul className="grid grid-cols-1 md:col-span-8 md:grid-cols-3">
          {PILLAR_KEYS.map((key, index) => (
            <li
              key={key}
              className={`flex flex-col gap-3 py-6 md:px-8 md:py-1 ${
                index > 0
                  ? 'border-t border-ink-100/15 md:border-t-0 md:border-l'
                  : 'pt-0 md:pl-0'
              }`}
            >
              <span className="font-display text-[24px] leading-[1.1] font-medium tracking-[-0.01em] text-blue-500 italic md:text-[28px]">
                {t(`PILLARS.${key}.TITLE`)}
              </span>
              <p className="text-[15px] leading-relaxed text-ink-200 md:text-base">
                {t(`PILLARS.${key}.BODY`)}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default React.memo(ThreePillars)
